import { Image, Wrapper } from './vendor_logo.styles';

import { VENDOR_BUSINESS_NAME } from '../../constants';

import saladStoryLogo from '../../static/saladstory-mono.svg';

type VendorLogoProps = { width?: number };

export default function VendorLogo({ width = 180 }: VendorLogoProps) {
  const height = width * (90 / 366);

  return (
    <Wrapper>
      <Image alt={VENDOR_BUSINESS_NAME} height={height} src={saladStoryLogo} width={width} />
    </Wrapper>
  );
}
